import { date } from 'locutus/php/datetime/date';
import { strtotime } from 'locutus/php/datetime/strtotime';

export default {
    required_html: '<sup class="required text-danger">*</sup>',

    init: function() {
        this.watch_date_range();
    },

    clear: function(dom) {
        dom.querySelectorAll('input, select, textarea').forEach(field => {
            if (field.type === 'checkbox' || field.type === 'radio') {
                field.checked = false;
            } else if (field.type !== 'submit') {
                field.value = '';
            }

            if (field.required) {
                field.classList.add('border-warning');
            }
        });

        dom.querySelectorAll('textarea.editor,textarea.tinymce').forEach(field => {
            field.value = '';

            window.tinymce.get(field.id).setContent('');
        });

        dom.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(field => field.removeAttribute('checked'));
    },

    make_select: (object, value_key, id_key, label) => {
        if (typeof (object) !== 'object' && typeof (object) !== null) {
            console.error(410, 'Object is not an Object');

            return;
        }

        let html = '<option value="">' + (label ? label : 'Select&hellip;') + '</option>';

        if (object) {
            for (let entry in object) {
                html += '<option value="' + object[entry][id_key ?? 'id'] + '">' + object[entry][value_key] + '</option>';
            }
        }

        return html;
    },

    populate(dom, data) {
        for (let key in data) {
            let element = dom.querySelector('[name="' + key + '"]');

            if (element) {
                if (element.type === 'checkbox' || element.type === 'radio') {
                    element.checked = element.value == data[key];
                } else {
                    if (element.type === 'textarea' && (element.classList.contains('editor') || element.classList.contains('tinymce'))) {
                        window.tinymce.get(element.id).setContent(data[key]);
                    }

                    element.value = data[key];
                }
            }
        }
    },

    populate_dates_from_range:function(date_range, with_time) {
        let end_date      = '';
        let end_sibling   = '';
        let range         = Number(date_range.value);
        let start_date    = '';
        let start_sibling = '';

        // If no range or is custom
        if (range !== 0 && range !== 0) {
            let end_format   = 'Y-m-d';
            let end_string   = 'now';
            let start_format = 'Y-m-d';
            let start_string = 'now';

            if (range === 1) {
                end_string   = 'today';
                start_string = 'today';
            } else if (range === 2) {
                end_string   = 'yesterday';
                start_string = 'yesterday';
            } else if (range === 3) {
                end_string   = 'sunday this week';
                start_string = 'monday this week';
            } else if (range === 4) {
                start_string = '-6 days';
            } else if (range === 5) {
                end_string   = 'sunday last week';
                start_string = 'monday last week';
            } else if (range === 6) {
                end_string   = 'last day of this month';
                start_format = 'Y-m-01';
            } else if (range === 7) {
                start_string = '-30 days';
            } else if (range === 8) {
                end_string   = 'last day of last month';
                start_format = 'Y-m-01';
                start_string = 'last month';
            } else if (range === 9) {
                end_format   = 'Y-12-31';
                end_string   = 'this year';
                start_format = 'Y-01-01';
                start_string = 'this year';
            } else if (range === 10) {
                start_string = '-1 year +1 day';
            } else if (range === 11) {
                end_format   = 'Y-12-31';
                end_string   = 'last year';
                start_format = 'Y-01-01';
                start_string = 'last year';
            }

            end_date   = date(end_format, strtotime(end_string));
            start_date = date(start_format, strtotime(start_string));
        }

        end_sibling   = nextSibling(date_range.parentNode, '.jb-date-range-end');
        start_sibling = nextSibling(date_range.parentNode, '.jb-date-range-start');

        if (with_time) {
            end_sibling.querySelector('[name^="_"][name$="_date"]').value   = end_date;
            start_sibling.querySelector('[name^="_"][name$="_date"]').value = start_date;

            end_sibling.querySelector('[name^="_"][name$="_hour"]').value   = '23';
            end_sibling.querySelector('[name^="_"][name$="_minute"]').value = '59';

            start_sibling.querySelector('[name^="_"][name$="_hour"]').value   = '00';
            start_sibling.querySelector('[name^="_"][name$="_minute"]').value = '00';
        } else {
            end_sibling.querySelector('input').value   = end_date;
            start_sibling.querySelector('input').value = start_date;
        }
    },

    select_texts: (dom) => {
        if (typeof dom === null) {
            window.console.error('Invalid DOM element provided');
        } else if (typeof dom === 'string') {
            dom = document.querySelector(dom);
        }

        return Array.from(dom.options)
            .filter(option => option.selected)
            .map(option => option.innerText);
    },

    select_values: (dom) => {
        if (typeof dom === null) {
            window.console.error('Invalid DOM element provided');
        } else if (typeof dom === 'string') {
            dom = document.querySelector(dom);
        }

        return Array.from(dom.options)
            .filter(option => option.selected)
            .map(option => option.value);
    },

    set_date_range_as_custom:function(dates) {
        dates.forEach(date => {
            date.addEventListener('change', function() {
                let closest = date.closest('.h-datetime');

                if (!closest) {
                    closest = date.closest('.form-group');
                }

                let range_field = previousSibling(closest, '.date-range-outer');

                if (range_field) {
                    range_field.querySelector('select').value = 12;
                }
            });
        });
    },

    set_required:function(element) {
        let input = false;

        if (typeof element !== 'object') {
            element = document.querySelector(element);
        }

        if (/^(?:input|select|textarea|button)$/i.test(element.nodeName)) {
            input = element;
        } else if (element.classList.contains('form-group')) {
            input = element.querySelector('button,input,select,textarea');
        } else {
            element.querySelectorAll('button,input,select,textarea').forEach(e2 => this.set_required(e2));

            return true;
        }

        let group = input.closest('.form-group');
        let label = group.querySelector('label');

        input.setAttribute('required', 'required');
        input.classList.add('border-warning');

        if (!label.innerHTML.includes(this.required_html)) {
            label.innerHTML += this.required_html;
        }

        return true;
    },

    unset_required:function(element) {
        let input = false;

        if (typeof element !== 'object') {
            element = document.querySelector(element);
        }

        if (/^(?:input|select|textarea|button)$/i.test(element.nodeName)) {
            input = element;
        } else if (element.classList.contains('form-group')) {
            input = element.querySelector('button,input,select,textarea');
        } else {
            element.querySelectorAll('button,input,select,textarea').forEach(e2 => this.unset_required(e2));

            return true;
        }

        let group = input.closest('.form-group');
        let label = group.querySelector('label');

        input.removeAttribute('required');
        input.classList.remove('border-warning');

        if (label.innerHTML.includes(this.required_html)) {
            label.innerHTML = label.innerHTML.replace(this.required_html, '');
        }

        return true;
    },

    validate: (form, event) => {
        let fields   = form.querySelectorAll('.form-check-input,.form-control,.form-select,input[type="hidden"]');
        let is_form  = form.tagName === 'FORM';
        let is_valid = true;

        JellyBelly.set_hidden(form.querySelector('.js-error'));

        if (!is_form) {
            form = document.createElement('form');

            for (let i = 0;i < fields.length; i++) {
                let field = fields[i].cloneNode(true);

                if (field.tagName === 'SELECT') {
                    field.value = fields[i].options[fields[i].selectedIndex].value;
                }

                form.appendChild(field);
            }
        }

        if (fields.length) {
            for (let i = 0;i < fields.length;i++) {
                let field         = fields[i];
                let field_wrapper = field.closest('.form-group');
                let invalid       = field_wrapper?.querySelector('.invalid-feedback');

                if (invalid) {
                    field.classList.remove('border-warning');

                    invalid.innerHTML = invalid.dataset.defaultError;
                }
            }
        }

        if (is_valid === false || form.checkValidity() === false) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (!is_form) {
                JellyBelly.unset_hidden(form.closest('form').querySelector('.js-error'));
                form.closest('form').classList.add('was-validated');
            } else {
                JellyBelly.unset_hidden(form.querySelector('.js-error'));
                form.classList.add('was-validated');
            }

            JellyBelly.hide_loader();

            return false;
        }

        form.classList.add('was-validated');

        return new FormData(form);
    },

    watch_date_range: function() {
        let end_dates = document
            .querySelectorAll('.jb-date-range [name="end_date"],.jb-date-range [name^="_"][name$="end_date_date"]');
        let date_ranges = document.querySelectorAll('.jb-date-range select.date_range');
        let start_dates = document
            .querySelectorAll('.jb-date-range [name="start_date"],.jb-date-range [name^="_"][name$="start_date_date"]');

        if (date_ranges.length) {
            date_ranges.forEach(date_range => {
                let event     = new CustomEvent('date-range-change');
                let with_time = Number(date_range.dataset.withTime) === 1 ? true : false;

                if (date_range.value !== '12') {
                    this.populate_dates_from_range(date_range, with_time);
                }

                date_range.addEventListener('change', () => {
                    this.populate_dates_from_range(date_range, with_time);
                    date_range.dispatchEvent(event);
                }, false);
            });
        }

        if (start_dates.length) {
            this.set_date_range_as_custom(start_dates);
        }

        if (end_dates.length) {
            this.set_date_range_as_custom(end_dates);
        }

        document
            .querySelectorAll('.jb-date-range [name$="start_date"], .jb-date-range [name$="start_date_date"]')
            ?.forEach(start => {
                let closest = start.closest('.jb-datetime');

                if (!closest) {
                    closest = start.closest('.form-group');
                }

                let end = closest
                    .nextElementSibling
                    .querySelector('[name$="end_date"],[name^="_"][name$="end_date_date"]');

                start.addEventListener('change', () => end.min = start.value);
            });
    }
};
